/* eslint-disable no-unused-vars */
import React from "react";

const NotFound = (props) => {

  return (
    <React.Fragment>
        Not Found
    </React.Fragment>
  );
};

export default NotFound;
